function isInternetExplorerDevice() {
  var userAgent = navigator.userAgent;
  return (
    userAgent.toUpperCase().indexOf("TRIDENT/") !== -1 ||
    userAgent.toUpperCase().indexOf("MSIE") !== -1
  );
}

export default isInternetExplorerDevice;
